import dlv from 'dlv'
import { isToday, isTomorrow } from 'date-fns'
import fetch from './fetch.js'
import { pad } from './utils.js'

let $container = document.querySelector('.js-flights')
let calendarIcon = `<svg width="16" height="16" viewBox="0 0 16 16" class="relative mr-2" style="top:-0.1em;">
<g fill="none" stroke="#000" fill-rule="evenodd">
  <rect width="11" height="10" x="2.5" y="3.5"/>
  <path stroke-linecap="square" d="M4.5 2.5v2m7-2v2m1 2h-9"/>
</g>
</svg>`

let transform = {
  scheduled_time (val, context) {
    return val
      .split(' ')
      .pop()
      .substr(0, 5)
  },
  status (val, context) {
    if (context.status_time) {
      return val + ' ' + context.status_time
    }
    return val
  },
  url (val, context, type) {
    let codes =
      type === 'departures'
        ? `LBA/${context.airport_iata}`
        : `${context.airport_iata}/LBA`
    return `/flights/${codes}/${
      context.flight_ident
    }/${context.scheduled_time.replace(' ', 'T')}`
  },
  datetime (val, context) {
    return context.scheduled_time.replace(' ', 'T')
  },
  flight_ident (val, context) {
    return `${val}<span class="xl:hidden"><br class="hidden sm:block"><span class="sm:hidden"> - </span>${
      context.airline
    }</span>`
  },
  flight_number (val, context) {
    return `${context.flight_ident}`
  },
  message (val, context) {
    let gate = context.gate
    if (gate && !new RegExp(`gate ${gate}`, 'i').test(val)) {
      return `Gate ${gate}. ${val}`
    }
    return val
  }
}

if ($container) {
  let type = $container.getAttribute('data-type')
  let $table = $container.querySelector('table')
  let $tBody = $table.querySelector('tbody')
  let template = $container.querySelector('.js-template').innerHTML
  let loading = false

  // eslint-disable-next-line
  function loadPage(page) {
    if (loading) return
    loading = true
    return fetch(`https://${window.LBA.apiDomain}/${type}`)
      .then(res => res.json())
      .then(flights => {
        let date = null
        let count = -1

        $tBody.innerHTML = flights
          .sort((a, b) => {
            return new Date(a.scheduled_time) - new Date(b.scheduled_time)
          })
          .map((flight, i) => {
            count++
            let header = ''
            let d = flight.scheduled_time.split(' ')[0]
            if (d !== date) {
              let [year, month, day] = flight.scheduled_time
                .split('-')
                .map(x => parseInt(x, 10))
              let dt = new Date(year, month - 1, day)
              header = `<tr><th colspan="7" class="font-secondary font-bold text-xxs tracking-wide uppercase border-t-2 border-grey-light py-5"><div class="flex items-center" style="padding-left:6px;">${calendarIcon}${
                isToday(dt) ? 'Today - ' : isTomorrow(dt) ? 'Tomorrow - ' : ''
              }${formatDate(dt)}</div></th></tr>`
              count = 0
            }
            date = d
            return {
              ...flight,
              classname: count % 2 === 0 ? 'bg-grey-lighter' : '',
              header
            }
          })
          .reduce((html, flight) => {
            return (
              html +
              flight.header +
              template.replace(/\{([a-z-_.]+)\}/g, (m, p1) => {
                let val = dlv(flight, p1) || ''
                if (transform[p1]) {
                  return transform[p1](val, flight, type)
                }
                return val
              })
            )
          }, '')

        loading = false
      })
  }

  loadPage(1)
}

function formatDate (date) {
  let months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ]
  return `${pad('00', date.getDate().toString())} ${
    months[date.getMonth()]
  } ${date.getFullYear()}`
}



// WEBPACK FOOTER //
// ./src/js/_flights.js